import styled, { css } from 'styled-components';
import constants from 'src/constants';

const { DEVICE } = constants.breakpoint;

// the position has to be fixed due to a scroll behavior in chrome/firefox
// and hight values of the webview will hide absolute values at the
//  bottom of the page until the user holds and scrolls up on a button
export const ControlBarContainer = styled.div`
  position: fixed;
  bottom: 10px;
  right: ${({ isOnlyShareRendered }) =>
    isOnlyShareRendered ? '25px' : '55px'};

  ${({ isDisabled }) =>
    isDisabled
      ? `
    pointer-events: none;
  `
      : ''}

  .view-options, .view-menu {
    position: absolute;
    bottom: 34px;
    right: 0px;
    min-width: 120px;
    background-color: ${({ theme }) => theme.colors.white};

    &.hide {
      display: none;
    }
  }

  @media ${DEVICE.MOBILE_LANDSCAPE} {
    right: 45px;
    bottom: 15px;
  }
`;

const MenuItemStyles = css`
  display: flex;
  padding: 15px 20px;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.defaultActionBlue};

    rect {
      fill: #247ddc;
    }

    path {
      fill: ${({ theme }) => theme.colors.white};
    }
  }
`;

export const MenuItem = styled.div`
  ${MenuItemStyles}
`;

const buttonStyles = css`
  padding: 10px 12px;
  line-height: 12px;
  font-size: 13px;
  margin: 0;
  border: 1px ${({ theme }) => theme.colors.licorice} solid;
  border-left-width: 1px;
  border-right-width: 1px;
  border-radius: 0px;
  background-color: ${({ theme }) => theme.colors.whiteTwo};
  box-sizing: border-box;
  margin-left: -1px;
  color: ${({ theme }) => theme.colors.licorice};
  box-shadow: none;

  &:first-of-type {
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
  }
  &:last-of-type {
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
  }
  &:hover {
    background-color: ${({ theme }) => theme.colors.mediumGrayTwo};
    color: ${({ theme }) => theme.colors.licorice};
  }
  &:focus {
    outline: none;
    background-color: ${({ theme }) => theme.colors.whiteTwo};
    color: ${({ theme }) => theme.colors.licorice};
  }

  &:disabled {
    background-color: ${({ theme }) => theme.colors.grayButtonHoverBackground};
    color: ${({ theme }) => theme.colors.lightGrayText};
    border-color: ${({ theme }) => theme.colors.lightGrayText};

    &:hover {
      background-color: ${({ theme }) =>
        theme.colors.grayButtonHoverBackground};
      color: ${({ theme }) => theme.colors.lightGrayText};
      border-color: ${({ theme }) => theme.colors.lightGrayText};
    }
  }
`;

export const ShareButton = styled.button`
  ${buttonStyles}
`;

export const CameraButton = styled.button`
  ${buttonStyles}
`;

export const ViewNavigatorMenuButton = styled.button`
  ${buttonStyles}
  color: ${({ isExpanded, theme }) =>
    isExpanded ? theme.colors.whiteTwo : theme.colors.licorice};
  background-color: ${({ isExpanded, theme }) =>
    isExpanded ? theme.colors.darkGray2 : theme.colors.whiteTwo};
  &:focus {
    background-color: ${({ isExpanded, theme }) =>
      isExpanded ? theme.colors.darkGray2 : theme.colors.whiteTwo};
    color: ${({ isExpanded, theme }) =>
      isExpanded ? theme.colors.whiteTwo : theme.colors.licorice};
  }
  &:hover {
    background-color: ${({ isExpanded, theme }) =>
      isExpanded ? theme.colors.darkGray2 : theme.colors.mediumGrayTwo};
    color: ${({ isExpanded, theme }) =>
      isExpanded ? theme.colors.whiteTwo : theme.colors.licorice};
  }
`;

export const UndoRedoButton = styled.button`
  ${buttonStyles}
`;
